<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
        viewBox="0 0 52 50"
        version="1.1"
        :class="customClasses"
    >
        <defs></defs>
        <g id="Skisser" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
            <g id="Mina-Sidor-Hyressökande-Notifiering" :fill="hexColor" sketch:type="MSArtboardGroup" transform="translate(-444.000000, -756.000000)">
                <path d="M461.105532,764.114977 L461.105532,776.989996 L447.041135,776.989996 L447.041135,804.02948 L444.971695,804.02948 L444.971695,806 L464,806 L479,806 L493.024536,806 L495.029968,806 L495.029968,804.02948 L493.024536,804.02948 L493.024536,776.011597 L489.998308,776.011597 L489.998308,771.048009 L484.0401,771.048009 L484.0401,764.114977 L481.011551,764.114977 L481.011551,771.048009 L479,771.048009 L479,756 L461.105532,764.114977 Z M463,765.420039 L463,804 L477,804 L477,759.081467 L463,765.420039 Z M483.015625,772 L483.015625,764.995972 L482.015625,764.995972 L482.015625,772 L478.933235,772 L478.933235,804.002697 L491.993286,804.002697 L491.993286,777.011597 L489,777.011597 L489,772 L483.015625,772 Z M448,778 L448,804 L461,804 L461,778 L448,778 Z M450,782 L450,784 L451,784 L451,782 L450,782 Z M454,782 L454,784 L455,784 L455,782 L454,782 Z M458,782 L458,784 L459,784 L459,782 L458,782 Z M450,786 L450,788 L451,788 L451,786 L450,786 Z M454,786 L454,788 L455,788 L455,786 L454,786 Z M458,786 L458,788 L459,788 L459,786 L458,786 Z M465,771 L465,772 L475,772 L475,771 L465,771 Z M465,768 L465,769 L475,769 L475,768 L465,768 Z M465,774 L465,775 L475,775 L475,774 L465,774 Z M465,777 L465,778 L475,778 L475,777 L465,777 Z M465,780 L465,781 L475,781 L475,780 L465,780 Z M465,788 L465,789 L475,789 L475,788 L465,788 Z M465,791 L465,792 L475,792 L475,791 L465,791 Z M465,794 L465,795 L475,795 L475,794 L465,794 Z M465,797 L465,798 L475,798 L475,797 L465,797 Z M465,800 L465,801 L475,801 L475,800 L465,800 Z M480,776 C480.552285,776 481,775.552285 481,775 C481,774.447715 480.552285,774 480,774 C479.447715,774 479,774.447715 479,775 C479,775.552285 479.447715,776 480,776 Z M483,776 C483.552285,776 484,775.552285 484,775 C484,774.447715 483.552285,774 483,774 C482.447715,774 482,774.447715 482,775 C482,775.552285 482.447715,776 483,776 Z M486,776 C486.552285,776 487,775.552285 487,775 C487,774.447715 486.552285,774 486,774 C485.447715,774 485,774.447715 485,775 C485,775.552285 485.447715,776 486,776 Z" id="building_L" sketch:type="MSShapeGroup"></path>
            </g>
        </g>
    </svg>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue'

    export default defineComponent({
        props: {
            size: {
                type: String,
                required: false,
                default: 'small'
            },
            hexColor: {
                type: String,
                required: false,
                default: '#000000'
            }
        },
        setup(props) {
            const customClasses = ref({
                'icon': true,
                'icon--small': props.size === 'small',
                'icon--medium': props.size === 'medium',
                'icon--large': props.size === 'large'
            })

            return {
                customClasses
            }
        }
    })
</script>
